import { createSlice } from '@reduxjs/toolkit';

export const attributionToken = createSlice({
  name: 'attributionToken',
  initialState: {
    data: '',
  },

  reducers: {
    setAttributionToken: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setAttributionToken } = attributionToken.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getAttributionToken = (state) => {
  return state.attributionToken.data;
};

export default attributionToken.reducer;
